import { AlertLayout, AlertSeverity } from 'omakase/Alert/Alert';
import { Theme, css } from '@emotion/react';

const ICON_DIAMETER = 20;

export const base =
  ({ layout, severity }: { layout: AlertLayout; severity: AlertSeverity }) =>
  ({ colors, spacing }: Theme) => [
    css`
      &.MuiAlert-root {
        border-radius: 0;
        border: 1px solid;
        display: grid;
        grid-template-columns: min-content 1fr;
        padding: ${spacing(layout === 'column' ? 2 : 1.5)}px;
      }

      & .MuiAlert-icon {
        color: ${colors.fgDefault};
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        justify-content: flex-start;
        width: ${ICON_DIAMETER}px;
        & svg {
          display: block;
          height: auto;
          width: 100%;
        }
      }

      &.MuiAlert-standardInfo {
        background: ${severity === 'basic' ? colors.bgLighter : colors.bgPrimaryLighter};
        border-color: ${severity === 'basic' ? colors.borderDefault : colors.borderPrimaryLight};
      }

      &.MuiAlert-standardSuccess {
        background: ${colors.bgSuccessLighter};
        border-color: ${colors.borderSuccessLight};
      }

      &.MuiAlert-standardWarning {
        background: ${colors.bgWarningLighter};
        border-color: ${colors.borderWarningLight};
      }

      &.MuiAlert-standardError {
        background: ${colors.bgDangerLighter};
        border-color: ${colors.borderDangerLight};
      }

      & > .MuiAlert-icon {
        padding: 0;
        margin-right: ${spacing(2)}px;
      }

      & > .MuiAlert-message {
        display: flex;
        flex-direction: column;
        justify-content: center;
        grid-column: 2;
        padding: 0;
        white-space: pre-wrap;
      }

      & > .MuiAlert-action {
        grid-column: ${layout === 'column' ? 2 : 3};
        margin: ${spacing(layout === 'column' ? 1.25 : 0)}px 0 0;
        padding: 0;
      }
    `,
    layout === 'row' &&
      css`
        & > .MuiAlert-icon {
          justify-content: center;
        }
      `,
  ];

export const title = ({ colors, typography, spacing }: Theme) => css`
  &.MuiAlertTitle-root {
    ${typography.variant('body02Strong')}
    color: ${colors.fgDefault};

    margin-top: ${spacing(0.25)}px;
    margin-bottom: ${spacing(1.25)}px;
  }
`;
